"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const addresses = {
    Governor: '0xA7499Aa6464c078EeB940da2fc95C6aCd010c3Cc',
    Guardian: '0x13Bf4cC864916cB6d8a74A5c9A9ac56931e95125',
};
exports.default = addresses;
//# sourceMappingURL=zksync.js.map